export default "__VITE_ASSET__CSoxXKYf__"